import it_faq from "./faq/it_faq";
import it_form from "./form/it";

const it = {
    entity_user: "Gestione delle utenze in sistema",
    entity_role: "Gestione dei ruoli di autorizzazione in sistema",
    name_and_surname: "Nome e cognome",
    entity_audit: "Gestione dell'audit",
    language_it: "Italiano",
    language_en: "English",
    language: "Lingua",
    disabled_user: "Utente disabilitato",
    enter_name_and_surname: "Inserisci nome e cognome",
    enter_name_or_email: "Inserisci email e nome",
    need_to_select_a_role: "Devi selezionare un ruolo",
    delete_user: "Eliminare l'utenza?",
    disabled: "Disabilitato",
    user_updated_successfully: "Utenza aggiornata con successo",
    user_deleted_successfully: "Utenza eliminata con successo",
    user_created_successfully: "Utente creato con successo",
    description: "Descrizione",
    role_name: "Nome ruolo",
    add_role_name: "Inserisci il nome del ruolo",
    add_role: "Aggiungi ruolo",
    add_user: "Aggiungi utente",
    deleted_role: "Ruolo eliminato",
    updated: "Aggiornati",
    delete_element: "Eliminare l'elemento?",
    role_already_used: "Ruolo già in uso!",
    role_created_successfully: "Ruolo creato con successo",
    add: "Aggiungi",
    server_error: "Errore del server",
    confirm_new_password: "Conferma nuova password",
    passwords_not_matching: "Le due password non coincidono",
    password_without_spaces: "La password non deve contenere spazi",
    password_length: "La password deve essere lunga almeno 8 caratteri",
    signup: "Registrati",
    error_while_saving: "Errore durante il salvataggio",
    authentication_failed: "Autenticazione fallita",
    send: "Invia",
    user_not_found: "Utente non trovato",
    wrong_old_password: "Vecchia password errata",
    enter_actual_password: "Inserisci password attuale",
    actual_password: "Password attuale",
    new_password: "Nuova password",
    email: "Email",
    name: "Nome",
    role: "Ruolo",
    user_type: "Tipo utente",
    my_profile: "Il mio profilo",
    access_denied: "Accesso negato",
    password_updated_successfully: "Password modificata con successo",
    submit_password: "Invia password",
    enter_your_email_address:
        "Inserisci l'indirizzo email associato alla tua utenza",
    restore_password: "Recupera password",
    forgot_password: "Password dimenticata?",
    edit_password: "Modifica password",
    show_password: "Mostra password",
    form_error: "Controlla i campi del form",
    enter_email: "Inserisci email",
    missing_sender_mail: "Mail del mittente mancante",
    log_into_your_account: "Entra nel tuo account",
    wrong_email_or_password: "Email o password sbagliati",
    unregistered_email: "Email non registrata",
    forgot_password_msg: "Mail inviata! Se non ricevi alcuna notizia da noi nei prossimi 15 minuti, controlla di aver inserito l'indirizzo e-mail corretto e controlla nella cartella spam.",
    roles: "Ruoli",
    roles_displayed_rows: "{from}-{to} di {count} ruoli",
    users: "Utenti",
    users_displayed_rows: "{from}-{to} di {count} utenti",
    components: "Componenti",
    Home: "Home",
    Profile: "Profilo",
    Ai_act: "AI-Act",
    About: "About",
    Impact_tool: "Impact Tool",
    Projects: "Progetti",
    maps: "Mappe",
    tables: "Tabelle",
    graphs: "Grafici",
    users_settings: "Gestione utenze",
    welcome: "Benvenuto",
    test: "test_it",
    audit: "Audit",
    frontend: "Frontend",
    backend: "Backend",
    file_picker_placeholder: "Seleziona uno o più file",
    success_ticket_sent: "Il ticket è stato aggiunto correttamente, prenderemo in carico la richiesta il prima possibile.",
    hubspot_portal: "Hubspot Customer Portal",
    size_limit_exceeded: "Dimensione massima superata",
    customer_portal_loading_failed: "Errore durante il caricamento del link al portale cliente",
    week_datepicker: "Settimana ",
    week_datepicker_not_selected: "Datepicker settimanale",
    daily_datepicker_not_selected: "Datepicker giornaliero",
    thanks: "Grazie!",
    select_an_option: "Seleziona un'opzione dal menu a tendina.",
    ticket_parameters_not_found: "Parametri di invio ticket non presenti",
    troisi_parameters_not_found: "Parametri di invio mail non presenti",
    error_new_ticket_creation: "Errore imprevisto nella creazione di un nuovo ticket",
    error_ticket_hubspot_management: "É stato creato un nuovo ticket, ma qualcosa è andato storto durante le operazioni effettuate dal nostro portale",
    error_ticket_file_attachment: "É stato creato un nuovo ticket, ma non è possibile allegare il file specificato",
    session_expired: "Sessione scaduta",
    refreshing_session_wait: "Rinnovo della sessione in corso, attendere...",

    selection: "Seleziona",
    projects: "Progetti",
    templates: 'Templates',
    search: "Cerca",
    version: "Versione",
    work_in_progress: "Lavori in corso",
    create_new_project: "Creare un nuovo progetto?",
    edit_project: "Modifica progetto",
    create_new_version: "Creare una nuova versione?",
    want_to_create_new_project: "Vuoi creare un nuovo progetto?",
    create: "Crea",
    cancel: "Annulla",
    title: "Titolo",
    version_name: "Nome versione",
    start_from_version: "Parti dalla versione",
    collaborators: "Collaboratori",
    you_must_insert_version: "Devi inserire la versione",
    you_must_insert_a_title: "Devi inserire un titolo",
    space_index_zero_is_reserved: "L'indice 0 è riservato",
    you_must_insert_version_title: "Devi inserire il titolo della versione",
    new_space_correctly_created: "Nuovo Space creato correttamente",
    edit_text: 'Modifica',
    new_element_correctly_created: "Nuovo elemento creato correttamente",
    no_text_inserted: "Nessun testo inserito",
    you_must_insert_collapsable_title: "Devi inserire il titolo del collapsable",
    new_section_correctly_created: "Nuova sezione creata correttamente",
    element_correctly_updated: "Elemento aggiornato correttamente",
    element_deleted: "Elemento eliminato",
    delete: "Elimina",
    create_by_me: "Creati da me",
    assign_to_me: "Assegnati a me",
    invitation_links: "Link di iscrizione",
    invitation_link: "Link invito",
    copy_invitation_link: "Copia link invito",
    add_one_or_more_emails: "Premere Invio o virgola per aggiungere una nuova email",
    duplicate: "Duplica",
    full_name_input_error: "Il nome completo deve essere almeno di 3 caratteri.",
    full_name: "Nome completo",
    user_already_exists: "utenza già registrata",
    error_send_invitation: "Invio invito fallito",
    no_projects_available: "Nessun progetto disponibile",
    new_project: "Nuovo progetto",
    download_pdf: "Scarica come PDF",
    graph_not_available: "Grafico non disponibile",
    not_rendered_in_pdf: "Non presente nel PDF",
    completed: "Completato",
    mark_as_completed: "Segna come completato",
    stop_editing: "Disattiva modifica",
    save: "Salva",
    saved: "Salvato",
    terms_and_conditions: "Accetta i nostri <a>Termini e Condizioni.</a>",
    registered_collaborators: "collaboratori registrati",
    unregistered_collaborators: "collaboratori non registrati",

    ...it_faq,
    ...it_form,
};

export default it;
